import { chartsBaseFeatureConfig } from './charts/base';
import { dashboardBaseFeatureConfig } from './dashboard/base';
import { documentsBaseFeatureConfig } from './documents/base';
import { exportBaseFeatureConfig } from './export/base';
import { miscBaseFeatureConfig } from './misc/base';
import { ordersBaseFeatureConfig } from './orders/base';
import { overviewBaseFeatureConfig } from './overview/base';
import { pipBaseFeatureConfig } from './pip/base';
import { priceAlertsBaseFeatureConfig } from './priceAlerts/base';
import { printBaseFeatureConfig } from './print/base';
import { productSettingsBaseFeatureConfig } from './productSettings/base';
import { profileBaseFeatureConfig } from './profile/base';
import { regularOrdersBaseFeatureConfig } from './regularOrders/base';
import { searchBaseFeatureConfig } from './search/base';
import { statementsBaseFeatureConfig } from './statements/base';
import { titleDetailBaseConfig } from './titleDetail/base';
import { tradingConfig } from './trading/base';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: InvestmentsFeatureConfig = {
    charts: chartsBaseFeatureConfig,
    dashboard: dashboardBaseFeatureConfig,
    documents: documentsBaseFeatureConfig,
    export: exportBaseFeatureConfig,
    misc: miscBaseFeatureConfig,
    orders: ordersBaseFeatureConfig,
    overview: overviewBaseFeatureConfig,
    pip: pipBaseFeatureConfig,
    priceAlerts: priceAlertsBaseFeatureConfig,
    print: printBaseFeatureConfig,
    productSettings: productSettingsBaseFeatureConfig,
    profile: profileBaseFeatureConfig,
    regularOrders: regularOrdersBaseFeatureConfig,
    search: searchBaseFeatureConfig,
    statements: statementsBaseFeatureConfig,
    titleDetail: titleDetailBaseConfig,
    trading: tradingConfig,
};
